import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useApi } from "@/core/api";
import type { Attachment } from "./enrich-attachments";

export const useAttachmentImage = (file: Attachment, visible = true) => {
  const api = useApi();
  const path = file.previewPath;
  const query = useQuery({
    queryKey: ["payroll-editor-image", path],
    queryFn: ({ signal }) => {
      const base = new URL(
        api.defaults.baseURL ?? "/api",
        window.location.origin,
      );
      return api
        .get<Blob>(new URL(path!, base).href, { signal, responseType: "blob" })
        .then((response) => response.data);
    },
    enabled: visible && !!path && !file.file,
    staleTime: Infinity,
    gcTime: 0,
    retry: false,
  });
  const blob = file.file ?? query.data;
  const [source, setSource] = useState<{ blob: Blob; url: string }>();
  useEffect(() => {
    if (!blob || !visible) return;
    const url = URL.createObjectURL(blob);
    setSource({ blob, url });
    return () => URL.revokeObjectURL(url);
  }, [blob, visible]);
  return {
    src: visible && source?.blob === blob ? source?.url : undefined,
    error: query.isError,
    retry: () => {
      if (path && !file.file) void query.refetch();
    },
  };
};
